import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GUEST_ROUTES } from 'routes/routes';
import styled from 'styled-components';
import { errorAlert } from 'ui-kit/Alert';

import TrackingAPI from '../../../api/TrackingAPI';
import UIHelper from '../../../helpers/UIHelper';
import Modal from '../../../ui-kit/Modal';

const isServer = typeof window === 'undefined';

const AdultWebsiteModal = () => {
  const isDreamRoleOrErogination = UIHelper.isDreamRoleOrErogination();
  const [adultWarnAccepted, setAdultModal] = useState(isServer ? false : localStorage.getItem('adult_modal'));
  const location = useLocation();

  const isPrivacyPolicyPage = location.pathname === GUEST_ROUTES.PRIVACY_POLICY();
  const isTermsOfServicePage = location.pathname === GUEST_ROUTES.TERMS_OF_SERVICE();

  if (adultWarnAccepted || isDreamRoleOrErogination || isPrivacyPolicyPage || isTermsOfServicePage || isServer) {
    return null;
  }

  return (
    <Modal isOpen={true} classname="email-confirmation-modal">
      <h1 className="text-center text-xl font-bold leading-8 text-white">
        This is an adult website
      </h1>
      <p className='text-center font-["Nunito_Sans"] text-base leading-[18px] text-white'>
        By entering, I confirm that I am at least 18
        <br /> years old
      </p>
      <div className="flex w-full flex-col items-center justify-center gap-4 pt-6">
        <AdultButton
          className='w-full rounded-full bg-[rgb(255,126,85)] px-4 py-2 font-["Nunito_Sans"] text-lg font-bold leading-6 text-white md:px-6 md:py-3'
          onClick={() => {
            if (!isServer) {
              localStorage.setItem('adult_modal', true);
              setAdultModal(true);
              TrackingAPI.trackEvent('adult_modal_yes_click');
            }
          }}
        >
          I am 18 or older — Enter
        </AdultButton>
        <button
          className='w-full rounded-full border border-[rgb(255,126,85)] px-4 py-2 font-["Nunito_Sans"] text-lg font-bold leading-6 text-white text-[rgb(255,126,85)] md:px-6 md:py-3'
          onClick={() => {
            errorAlert('You must be at least 18 years of age');
            TrackingAPI.trackEvent('adult_modal_no_click');
          }}
        >
          I am under 18 — Exit
        </button>
      </div>
    </Modal>
  );
};

export default AdultWebsiteModal;

const AdultButton = styled.button`
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);
`;
